import { createContext, useContext } from "react";
import type { PettyWork } from "features/PettyWorks/types/petty-work.types";

interface PettyWorkOverviewContextType {
  pettyWork: PettyWork | null;
  refetch: () => Promise<void>;
}

const PettyWorkOverviewContext =
  createContext<PettyWorkOverviewContextType | null>(null);

export const usePettyWorkOverview = () => {
  const context = useContext(PettyWorkOverviewContext);
  if (!context) {
    throw new Error("usePettyWorkOverview must be used within provider");
  }
  return context;
};

export default PettyWorkOverviewContext;
